import React, { useState, useEffect } from "react";
import Header from "../layouts/Employee/Header";
import SubHeader from "../layouts/Employee/SubHeader";
import { Calendar, momentLocalizer } from "react-big-calendar";
import moment from "moment";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "./Attendance.css";

const localizer = momentLocalizer(moment);

function Attendance() {
  const [myEventsList, setMyEventsList] = useState([
    {
      title: "On Time Arrival",
      type: "OnTime",
      start: new Date(2025, 6, 29, 9, 0),
      end: new Date(2025, 6, 29, 17, 0),
    },
    {
      title: "Late Arrival",
      type: "Late",
      start: new Date(2025, 6, 30, 9, 30),
      end: new Date(2025, 6, 30, 17, 0),
    },
    {
      title: "Business Leave",
      type: "Leave",
      start: new Date(2025, 7, 2, 8, 0),
      end: new Date(2025, 7, 4, 18, 0),
    },
  ]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [requestType, setRequestType] = useState("Overtime");
  const [details, setDetails] = useState("");
  const [currentDate, setCurrentDate] = useState(moment().format("dddd, MMMM D, YYYY"));
  const [currentTime, setCurrentTime] = useState(moment().format("hh:mm:ss A"));
  const [stats, setStats] = useState({ onTime: 0, late: 0, absent: 0, earlyOut: 0, leave: 0 });

  // ✅ Update stats dynamically
  useEffect(() => {
    const onTime = myEventsList.filter(e => e.type === "OnTime").length;
    const late = myEventsList.filter(e => e.type === "Late").length;
    const leave = myEventsList.filter(e => e.type === "Leave").length;

    // For demo: assuming 20 workdays this month
    const totalDays = 20;
    const attended = onTime + late + leave;
    const absent = totalDays - attended;
    const earlyOut = myEventsList.filter(e => e.type === "EarlyOut").length;

    setStats({ onTime, late, absent, earlyOut, leave });
  }, [myEventsList]);

  const handleDateClick = (slotInfo) => {
    setSelectedDate(slotInfo.start);
    setIsModalOpen(true);
  };

  const handleSaveRequest = () => {
    if (!selectedDate || !requestType) return;

    const newEvent = {
      title: requestType === "Overtime" ? "Overtime Application" : "Business Application",
      type: requestType === "Overtime" ? "OnTime" : "Leave", // just example classification
      start: selectedDate,
      end: new Date(selectedDate.getTime() + 2 * 60 * 60 * 1000),
    };

    setMyEventsList([...myEventsList, newEvent]);
    setIsModalOpen(false);
    setDetails("");
  };

  const handleTimeIn = () => {
    alert("✅ You have successfully timed in.");
  };

  const handleTimeOut = () => {
    alert("⏰ You have successfully timed out.");
  };

  return (
    <div>
      <Header />
      <SubHeader />
      <div className="attendance-header">
        {/* Left: Today's Date */}
        <div className="attendance-date-card">
          <span className="date-label">Today</span>
          <span className="time-value">{currentTime}</span>
          <span className="date-value">{currentDate}</span>
        </div>

        {/* Middle: Dynamic Stats */}
        <div className="attendance-stats">
          <div className="stat-card ontime">
            <i className="fa-solid fa-check-circle"></i>
            <div>
              <p>On Time</p>
              <span>{stats.onTime}</span>
            </div>
          </div>
          <div className="stat-card late">
            <i className="fa-solid fa-clock"></i>
            <div>
              <p>Late</p>
              <span>{stats.late}</span>
            </div>
          </div>
          <div className="stat-card absent">
            <i className="fa-solid fa-user-xmark"></i>
            <div>
              <p>Absent</p>
              <span>{stats.absent}</span>
            </div>
          </div>
          <div className="stat-card earlyout">
            <i className="fa-solid fa-arrow-right-from-bracket"></i>
            <div>
              <p>Early Out</p>
              <span>{stats.earlyOut}</span>
            </div>
          </div>
          <div className="stat-card leave">
            <i className="fa-solid fa-file"></i>
            <div>
              <p>Leave</p>
              <span>{stats.leave}</span>
            </div>
          </div>
        </div>

        {/* Right: Buttons */}
        <div className="attendance-actions">
          <button className="btn-timein" onClick={handleTimeIn}>Time In</button>
          <button className="btn-timeout" onClick={handleTimeOut}>Time Out</button>
        </div>
      </div>

      {/* === Calendar === */}
      <div style={{ padding: "20px" }}>
        <h2 style={{ marginBottom: "10px" }}>📅 Attendance Calendar</h2>
        <Calendar
          localizer={localizer}
          events={myEventsList}
          startAccessor="start"
          endAccessor="end"
          selectable
          onSelectSlot={handleDateClick}
          style={{ height: 500 }}
        />
      </div>

      {/* === Modal Popup === */}
      {isModalOpen && (
        <div className="attendance-overlay">
          <div className="attendance-modal">
            <h3>New Attendance Request</h3>
            <p>Date: {selectedDate?.toDateString()}</p>
            <label>Request Type:</label>
            <select
              value={requestType}
              onChange={(e) => setRequestType(e.target.value)}
              className="attendance-input"
            >
              <option value="Overtime">Overtime Application</option>
              <option value="Business">Business Application</option>
            </select>

            <label>Details:</label>
            <textarea
              placeholder="Enter details..."
              value={details}
              onChange={(e) => setDetails(e.target.value)}
              className="attendance-textarea"
            ></textarea>

            <div className="attendance-btn-container">
              <button onClick={handleSaveRequest} className="attendance-save-btn">
                Save
              </button>
              <button onClick={() => setIsModalOpen(false)} className="attendance-cancel-btn">
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Attendance;
